import React, { useEffect, useMemo, useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { signUpWithGoogle } from "../utils/firebase.utils";
import FormikForm from "../components/commonForm";
import {
  feildsLogin,
  initialValuesLogin,
  validationSchemaLogin,
} from "../fromsUtil/login.form";
import { logOut, login, loginGoogle } from "../logic/login/action";
import { useDispatch, useSelector } from "react-redux";
import logo from "../images/logo_clock.png";
import { toast } from "react-toastify";
import { RWebShare } from "react-web-share";
import { ShareSocial } from "react-share-social";
import { CircularProgress } from "@mui/material";
import { failedAuth, loadingAuth } from "../logic/login/reducer";
import { errorMessage } from "../logic/error/action";

const StaffLogin = () => {
  const route = useLocation();
  const nav = useNavigate();

  const superadmin = useMemo(() => {
    const dt = new URLSearchParams(route.search);
    if (dt.get("superadmin")) {
      return true;
    } else {
      return false;
    }
  }, [route.search]);

  useEffect(() => {
    console.log(superadmin, "how many");
    if (superadmin && type !== "admin") {
      settype("admin");
    }
  }, [superadmin]);

  const [type, settype] = useState("staff");

  const dispatch = useDispatch();
  const onSubmit = async (values, submitProps) => {
    await login(dispatch, values, type, nav);
    submitProps.setSubmitting(true);
    submitProps.resetForm();
  };

  const loginWithGoogle = async () => {
    dispatch(loadingAuth());
    const googleData = await signUpWithGoogle();
    if (googleData) {
      const req = {
        email: googleData.email,
        google_id: googleData.google_id,
        access_token: googleData.access_token,
        google_headers: JSON.stringify({
          Authorization: `Bearer ${googleData.access_token}`,
        }),
        fcm: "fcm",
      };
      loginGoogle(dispatch, req, nav);
    } else {
      dispatch(failedAuth({ message: 'Please select account' }));
      errorMessage(dispatch,'Please select account')
      // toast.error("Error while login with google", {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
    }
  };
  const selectorAuth = useSelector(state=>state.auth);

  return (
    <div className="w-screen bg-white h-auto flex flex-col items-center justify-center">
      {
        selectorAuth.status === 'loading'?
        <div className="w-screen z-20 h-screen bg-secondry/30 fixed top-0 left-0 flex items-center justify-center">
        <CircularProgress color="primary"/>
      </div>:<></>
      }
      <div className="bg-secondry/5 w-full">
        <header className="w-full lg:w-[80%] mx-auto flex items-center py-4 justify-between px-4">
          <a href="/">
            <img src={logo} className="w-20 h-20"></img>
          </a>
          <div className="flex items-center gap-2">
            <p className="hidden lg:inline-block">Need an account?</p>
            <Link to={"/admin/register"} onClick={() => logOut(dispatch)}>
              <p className="text-secondry border-b border-b-secondry">
                Sign Up
              </p>
            </Link>
          </div>
        </header>
      </div>
      <div className="bg-secondry/5 w-full">
        <div className="w-full  lg:w-[80%] mx-auto flex justify-center items-start gap-4 min-h-screen">
          <div className="flex-1 min-w-full lg:min-w-[45%] h-full p-4 lg:p-0 relative">
            <div className="bg-white shadow-2xl shadow-gray-200 rounded-lg w-full lg:w-[40%] mx-auto flex flex-col gap-4 lg:gap-8 p-4 lg:p-16">
              <h2 className="font-normal text-xl">Staff Login</h2>

              <button
                onClick={loginWithGoogle}
                className="button !from-white gap-2 !to-white !text-gray-600 font-normal border border-gray-400 w-full"
              >
                <FcGoogle size={"1.2rem"} />
                <span>Sign in with google</span>
              </button>
              <div className="flex items-center gap-2 w-full">
                <span className="flex-1 h-[0.05rem] bg-gray-300"></span>
                <p>OR</p>
                <span className="flex-1 h-[0.05rem] bg-gray-300"></span>
              </div>

              <FormikForm
                initialValues={initialValuesLogin}
                fields={feildsLogin}
                validationSchema={validationSchemaLogin}
                action={(disabled) => (
                  <button
                    disabled={disabled}
                    className="button w-full"
                    type="submit"
                  >
                    Login
                  </button>
                )}
                onSubmit={onSubmit}
              />
              <div className="w-full text-center">
                <Link to={"/admin/verify/forgot-password"}>
                  <p className="highlited">Forgotten your password?</p>
                </Link>
              </div>
              <div className="w-full text-center">
                <p className="text-gray-500 text-center text-xs w-full">
                  By signing in, you agree to our{" "}
                  <span className="text-secondry">Terms & Conditions</span> &{" "}
                  <br />
                  <span className="text-secondry">Privacy Policy.</span>
                </p>
                {/* <Link to={'/admin/verify'}><p className='highlited'>Forgotten your password?</p></Link> */}
              </div>
              {/* <button></button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffLogin;
